import React from 'react';
import { Link } from 'react-router-dom';
import './Footer.css';
import logo from './image/logo.png';

const Footer: React.FC = () => {
  const year = new Date().getFullYear();

  return (
    <footer className="footer">
      <div className="footer__top">
        <div className="footer__container">

          {/* Brand */}
          <div className="footer__brand">
            <div className="footer__brand-row">
              <img src={logo} alt="CECAP" className="footer__logo" />
              <span className="footer__brand-name">Cecap</span>
            </div>
            <p className="footer__brand-desc">
              Institución técnica en Maicao, La Guajira. Formamos profesionales competentes con visión empresarial y compromiso regional.
            </p>
            <div className="footer__social">
              {/* Facebook */}
              <a href="https://facebook.com" target="_blank" rel="noopener noreferrer" className="footer__social-link" aria-label="Facebook">
                <svg viewBox="0 0 24 24" fill="currentColor" width="18" height="18">
                  <path d="M18 2h-3a5 5 0 00-5 5v3H7v4h3v8h4v-8h3l1-4h-4V7a1 1 0 011-1h3z"/>
                </svg>
              </a>
              {/* Instagram */}
              <a href="https://instagram.com" target="_blank" rel="noopener noreferrer" className="footer__social-link" aria-label="Instagram">
                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" width="18" height="18">
                  <rect x="2" y="2" width="20" height="20" rx="5" ry="5"/>
                  <circle cx="12" cy="12" r="4"/>
                  <circle cx="17.5" cy="6.5" r="1" fill="currentColor" stroke="none"/>
                </svg>
              </a>
              {/* WhatsApp */}
              <a href="https://wa.me/573008158001" target="_blank" rel="noopener noreferrer" className="footer__social-link" aria-label="WhatsApp">
                <svg viewBox="0 0 24 24" fill="currentColor" width="18" height="18">
                  <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347z"/>
                  <path d="M12 0C5.373 0 0 5.373 0 12c0 2.118.554 4.107 1.523 5.836L.057 23.43a.5.5 0 00.513.57l5.747-1.505A11.943 11.943 0 0012 24c6.627 0 12-5.373 12-12S18.627 0 12 0zm0 22c-1.885 0-3.655-.523-5.165-1.432l-.37-.22-3.815.998 1.02-3.716-.242-.383A9.956 9.956 0 012 12C2 6.477 6.477 2 12 2s10 4.477 10 10-4.477 10-10 10z"/>
                </svg>
              </a>
            </div>
          </div>

          {/* Nav */}
          <div className="footer__nav-group">
            <h4 className="footer__nav-title">Institución</h4>
            <ul className="footer__nav-list">
              <li><Link to="/" className="footer__nav-link">Inicio</Link></li>
              <li><Link to="/Us" className="footer__nav-link">Quiénes Somos</Link></li>
              <li><Link to="/pricing" className="footer__nav-link">Programas y Servicios</Link></li>
              <li><Link to="/contact" className="footer__nav-link">Contacto</Link></li>
            </ul>
          </div>

          {/* Programas */}
          <div className="footer__nav-group">
            <h4 className="footer__nav-title">Programas</h4>
            <ul className="footer__nav-list">
              <li><Link to="/pricing" className="footer__nav-link">Administración Empresarial</Link></li>
              <li><Link to="/pricing" className="footer__nav-link">Contabilidad y Finanzas</Link></li>
              <li><Link to="/pricing" className="footer__nav-link">Seguridad y Salud en el Trabajo</Link></li>
              <li><Link to="/pricing" className="footer__nav-link">Atención a Primera Infancia</Link></li>
              <li><Link to="/pricing" className="footer__nav-link">Marketing Digital</Link></li>
            </ul>
          </div>

          {/* Contacto */}
          <div className="footer__nav-group">
            <h4 className="footer__nav-title">Contacto</h4>
            <ul className="footer__nav-list footer__contact-list">
              <li>
                <svg viewBox="0 0 24 24" fill="currentColor" width="14" height="14"><path d="M12 2C8.13 2 5 5.13 5 9c0 5.25 7 13 7 13s7-7.75 7-13c0-3.87-3.13-7-7-7zm0 9.5c-1.38 0-2.5-1.12-2.5-2.5s1.12-2.5 2.5-2.5 2.5 1.12 2.5 2.5-1.12 2.5-2.5 2.5z"/></svg>
                Cra. 7 #17-36, B. San José · Maicao, La Guajira
              </li>
              <li>
                <svg viewBox="0 0 24 24" fill="currentColor" width="14" height="14"><path d="M6.6 10.8c1.4 2.8 3.8 5.1 6.6 6.6l2.2-2.2c.3-.3.7-.4 1-.2 1.1.4 2.3.6 3.6.6.6 0 1 .4 1 1V20c0 .6-.4 1-1 1-9.4 0-17-7.6-17-17 0-.6.4-1 1-1h3.5c.6 0 1 .4 1 1 0 1.3.2 2.5.6 3.6.1.3 0 .7-.2 1L6.6 10.8z"/></svg>
                300 815 8001 · 301 222 7878
              </li>
              <li>
                <svg viewBox="0 0 24 24" fill="currentColor" width="14" height="14"><path d="M20 4H4c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zm0 4l-8 5-8-5V6l8 5 8-5v2z"/></svg>
                cecapmaicao@gmail.com
              </li>
              <li>
                <svg viewBox="0 0 24 24" fill="currentColor" width="14" height="14"><path d="M11.99 2C6.47 2 2 6.48 2 12s4.47 10 9.99 10C17.52 22 22 17.52 22 12S17.52 2 11.99 2zM12 20c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8zm.5-13H11v6l5.25 3.15.75-1.23-4.5-2.67V7z"/></svg>
                Lun–Sáb: 8am–12pm y 2pm–6pm
              </li>
            </ul>
          </div>

        </div>
      </div>

      {/* Bottom bar */}
      <div className="footer__bottom">
        <div className="footer__bottom-inner">
          <p className="footer__copy">© {year} CECAP Maicao. Todos los derechos reservados.</p>
          <p className="footer__tagline">Formación técnica para el desarrollo de La Guajira</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
